import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import UserSync from './UserSync';
import TaskCounter from './TaskCounter';

const DataSync = (props) => {
  return (
    <>
      <UserSync />
      <TaskCounter />
    </>
  );
};

DataSync.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(DataSync);
